function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import singleSpaEvents from '../../constants/singleSpaEvents';
import ilcEvents from '../../constants/ilcEvents';
var _targetHref = /*#__PURE__*/new WeakMap();
var _subscribed = /*#__PURE__*/new WeakMap();
var _hookList = /*#__PURE__*/new WeakMap();
var _logger = /*#__PURE__*/new WeakMap();
export var TransitionHooks = /*#__PURE__*/function () {
  function TransitionHooks(logger) {
    _classCallCheck(this, TransitionHooks);
    _classPrivateFieldInitSpec(this, _targetHref, void 0);
    _classPrivateFieldInitSpec(this, _subscribed, false);
    _classPrivateFieldInitSpec(this, _hookList, []);
    _classPrivateFieldInitSpec(this, _logger, void 0);
    _classPrivateFieldSet(_logger, this, logger);
  }
  return _createClass(TransitionHooks, [{
    key: "addHook",
    value: function addHook(hookInstance) {
      _classPrivateFieldGet(_hookList, this).push(hookInstance);
    }
  }, {
    key: "subscribe",
    value: function subscribe() {
      var _this = this;
      if (_classPrivateFieldGet(_subscribed, this)) {
        _classPrivateFieldGet(_logger, this).warn('ILC: TransitionHooks. Unexpected subscription happened');
        return;
      }

      // ToDo: avoid using singleSpaEvents.BEFORE_ROUTING_EVENT ans switch to ilc.BEFORE_ROUTING
      // Need to make it with increasing code coverage
      window.addEventListener(singleSpaEvents.BEFORE_ROUTING_EVENT, function () {
        // Check is needed as this event may be triggered 2 times
        // due to "app re-mount due to changed props" functionality
        if (_classPrivateFieldGet(_targetHref, _this) === window.location.href) {
          return;
        }
        try {
          _classPrivateFieldGet(_hookList, _this).forEach(function (hook) {
            hook.beforeHandler();
          });
        } catch (error) {
          _classPrivateFieldGet(_logger, _this).error('ILC: transition hooks before handler error');
        }
        _classPrivateFieldSet(_targetHref, _this, window.location.href);
      });
      window.addEventListener(ilcEvents.ALL_SLOTS_LOADED, function () {
        try {
          _classPrivateFieldGet(_hookList, _this).forEach(function (hook) {
            hook.afterHandler();
          });
        } catch (error) {
          _classPrivateFieldGet(_logger, _this).error('ILC: transition hooks after handler error');
        }
      });
      _classPrivateFieldSet(_subscribed, this, true);
    }
  }]);
}();